<template>
    <div id="nipos-filters" class="mb-1">
        <v-row>
            <!-- From Date -->
            <v-col md="2">
                <v-menu
                    v-model="filters.fromDate.modal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                ><template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="search.fromDate"
                        label="From Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        class="mt-0 pt-0"
                    ></v-text-field
                ></template>
                    <v-date-picker
                        v-model="search.fromDate"
                        @input="filters.fromDate.modal = false"
                        @click:date="handleDateFilters"
                    ></v-date-picker>
                </v-menu>
            </v-col>

            <!-- To Date -->
            <v-col md="2">
                <v-menu
                    v-model="filters.toDate.modal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                ><template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="search.toDate"
                        label="To Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        class="mt-0 pt-0"
                    ></v-text-field
                ></template>
                    <v-date-picker
                        v-model="search.toDate"
                        @input="filters.toDate.modal = false"
                        @click:date="handleDateFilters"
                    ></v-date-picker>
                </v-menu>
            </v-col>

            <!-- Card Issuer -->
            <v-col md="2" >
                <v-select
                    v-model="search.issuer"
                    :items="filters.issuers"
                    dense
                    label="Card Issuer"
                    append-icon="mdi-magnify"
                    class="mt-0 pt-0"
                    @change="updateSearch();"
                    clearable
                    @click:clear="search.issuer = null; updateSearch();"
                ></v-select>
            </v-col>

            <!-- Merchant IDs -->
            <v-col md="2" >
                <v-select
                    v-model="search.merchant_id"
                    :items="filters.merchant_ids"
                    dense
                    label="Merchant ID"
                    append-icon="mdi-magnify"
                    class="mt-0 pt-0"
                    @change="dynamicUpdate(dynamicFilterData.merchant_id, search.merchant_id);"
                    clearable
                    @click:clear="search.merchant_id = null; updateSearch();"
                ></v-select>
            </v-col>

            <!-- Chain IDs -->
            <v-col md="2" >
                <v-select
                    v-model="search.chain_id"
                    :items="filters.chain_ids"
                    dense
                    label="Chain ID"
                    append-icon="mdi-magnify"
                    class="mt-0 pt-0"
                    @change="dynamicUpdate(dynamicFilterData.chain_id, search.chain_id);"
                    clearable
                    @click:clear="search.chain_id = null; updateSearch();"
                ></v-select>
            </v-col>

            <!-- Merchant Names -->
            <v-col md="2" >
                <v-select
                    v-model="search.merchant_name"
                    :items="filters.merchant_names"
                    dense
                    label="Merchant Name"
                    append-icon="mdi-magnify"
                    class="mt-0 pt-0"
                    @change="updateSearch();"
                    clearable
                    @click:clear="search.merchant_name = null; updateSearch();"
                ></v-select>
            </v-col>

            <!-- Locations -->
            <v-col md="2" >
                <v-select
                    v-model="search.location"
                    :items="filters.locations"
                    dense
                    label="Location"
                    append-icon="mdi-magnify"
                    class="mt-0 pt-0"
                    @change="updateSearch();"
                    clearable
                    @click:clear="search.location = null; updateSearch();"
                ></v-select>
            </v-col>

            <!-- Payment Brands -->
            <v-col md="2" >
                <v-select
                    v-model="search.payment_brand"
                    :items="filters.payment_brands"
                    dense
                    label="Payment Brand"
                    append-icon="mdi-magnify"
                    class="mt-0 pt-0"
                    @change="updateSearch();"
                    clearable
                    @click:clear="search.payment_brand = null; updateSearch();"
                ></v-select>
            </v-col>

            <!-- Card Types -->
            <v-col md="2" >
                <v-select
                    v-model="search.card_type"
                    :items="filters.card_types"
                    dense
                    label="Card Type"
                    append-icon="mdi-magnify"
                    class="mt-0 pt-0"
                    @change="updateSearch();"
                    clearable
                    @click:clear="search.card_type = null; updateSearch();"
                ></v-select>
            </v-col>

            <!-- Ni Pos Merchants -->
            <v-col md="2" >
                <v-select
                    v-model="search.ni_pos_merchant"
                    :items="filters.ni_pos_merchants"
                    dense
                    label="Merchant Account"
                    append-icon="mdi-magnify"
                    class="mt-0 pt-0"
                    @change="dynamicUpdate(dynamicFilterData.merchant_account, search.merchant_account);"
                    clearable
                    @click:clear="search.ni_pos_merchant = null; dynamicClear();"
                ></v-select>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
    props: {
        search: Object,
    },

    data() {
        return {
            aggCols: [
                "merchant_account",
                "merchant_id",
                "chain_id"
            ],

            filters: {
                fromDate: {
                    modal: null,
                },
                toDate: {
                    modal: null,
                },
                issuers: [],
                merchant_ids: [],
                chain_ids: [],
                merchant_names: [],
                location: [],
                payment_brands: [],
                card_types: [],
                ni_pos_merchants: [],
            },

            initialFilterData: {},
            dynamicFilterData: {},

            loading: false,
            errors: [],
        }
    },

    beforeMount() {
        this.getFilterData();
        this.getFilterAggs();
    },
    
    methods: {
        masterReq(url, data={search: this.search}, responseType='json', method='post') {
            return axios({
                method: method,
                url: url,
                data: data,
                responseType: responseType,
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
        },

        getFilterData() {
            this.loading = true;

            this.masterReq('get-filter-data-live-ni-pos').then((response) => {
                this.loading = false;
                this.parseFilterData(response.data[0]);
            })
            .catch(e => {
                this.loading = false;
                this.errors.push(e);
            });
        },

        getFilterAggs() {
            this.aggCols.forEach(aggCol => {
                this.masterReq('get-filter-agg-live-ni-pos', {aggSearchCol: aggCol}).then((response) => {
                    this.parseAggData(aggCol, response.data);

                    console.log("dynamicFilterData:", this.dynamicFilterData);
                })
                .catch(e => {
                    console.log(e);
                    this.errors.push(e);
                });
            });
        },

        parseFilterData(filterData) {
            this.filters.issuers = filterData.card_issuer.split(";");
            this.filters.merchant_ids = filterData.merchant_id.split(";")
            this.filters.chain_ids = filterData.chain_id.split(";")
            this.filters.merchant_names = filterData.merchant_name.split(";")
            this.filters.locations = filterData.location.split(";")
            this.filters.payment_brands = filterData.payment_brand.split(";")
            this.filters.card_types = filterData.card_type.split(";")
            this.filters.ni_pos_merchants = filterData.merchant_account.split(";")

            // Create deep copy of initial filter data
            this.initialFilterData = Object.assign({}, this.filters); 
            console.log("initialFilterData", this.initialFilterData);
        },

        parseAggData(aggCol, aggData) {
            this.dynamicFilterData[aggCol] = aggData;
        },

        handleDateFilters() {
            if(this.search.toDate < this.search.fromDate) {
                this.search.fromDate = this.search.toDate;
            }
            this.updateSearch();
        },

        dynamicUpdate(dynamicFilterData, searchVal) {
            if (searchVal == null) {
                this.dynamicClear();
                return;
            }

            var dynIndex = this.getDynamicPosIndex(dynamicFilterData, searchVal);
            console.log("dynamic update", "dynamicFilterData", dynamicFilterData, "searchVal", searchVal, "dynIndex", dynIndex);

            this.search.ni_pos_merchant = dynamicFilterData[dynIndex]['merchant_account'];
            this.filters.merchant_ids = this.dynamicFilterData['merchant_id'][dynIndex]['aggData'].split(";");
            this.filters.chain_ids = this.dynamicFilterData['chain_id'][dynIndex]['aggData'].split(";");   

            this.updateSearch();
        },

        getDynamicPosIndex(haystack, needle) {
            for (const [key, value] of Object.entries(haystack)) {
                if (value['aggData'].includes(needle)) {
                    return key;
                }
            }

            return null;
        },

        dynamicClear() {
            console.log("dynamic clear: ", this.filters, this.initialFilterData);
            this.filters = this.initialFilterData;
            this.updateSearch();
        },

        updateSearch() {
            return this.$emit('search', this.search);
        },
    }
}
</script>

<style>

</style>